import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import Row from './Row';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Table = ({ pageLayout, data, fetchOrders, totalOrders }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: {
      referenceId,
      businessLegalName,
      orderStatus,
      createdAt,
      updatedAt,
      actions
    }
  } = localizedStrings;

  const headerList = [
    referenceId,
    businessLegalName,
    orderStatus,
    createdAt,
    updatedAt,
    actions
  ];

  return (
    <div className="responsive-table-container">
      <table className="responsive-table">
        <caption className="responsive-table__caption">
          {`${_.get(pageLayout, 'tableTitle', '')} (${totalOrders})`}
        </caption>
        <thead className="responsive-table__thead">
          <tr>
            {headerList.map(headerItem => (
              <th>{headerItem}</th>
            ))}
          </tr>
        </thead>
        <tbody className="responsive-table__tbody">
          {data &&
            data.map(order => (
              <Row
                key={order.id}
                order={order}
                pageLayout={pageLayout}
                fetchOrders={fetchOrders}
                header={headerList}
              />
            ))}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  pageLayout: PropTypes.objectOf(PropTypes.object).isRequired,
  data: PropTypes.objectOf(PropTypes.array).isRequired,
  fetchOrders: PropTypes.func.isRequired,
  totalOrders: PropTypes.number.isRequired
};

export default Table;
